import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { TForgotPass } from '../data/schemas/forgot-pass';

type TState = {
  forgotPassData: TForgotPass | null;
};

type TAction = {
  setForgotPass: (forgotPass: TForgotPass) => void;
  resetState: () => void;
};

export const useForgotPassStore = create<TState & TAction>()(
  immer((set) => ({
    forgotPassData: null,
    setForgotPass: (forgotPassData: TForgotPass) => {
      set((state) => {
        state.forgotPassData = forgotPassData;
      });
    },
    resetState: () => {
      set((state) => {
        state.forgotPassData = null;
      });
    },
  }))
);
